<template>
  <el-col :span="3" class="info">
    <el-row>
      <el-col :span="14" class="ta-r">
        <p>Контактов:</p>
        <p class="green">Обработано:</p>
        <p class="red">Осталось:</p>
      </el-col>
      <el-col :span="10" class="ta-l ml-10">
        <p>{{ stats.total }}</p>
        <p class="green">{{ stats.done }}</p>
        <p class="red">{{ stats.pending }}</p>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
export default {
  name: 'TaskStats',
  props: {
    stats: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass">
.cc-item
  min-height: 80px
  background: #fff
  margin-top: 20px
  font-size: 14px
  padding: 15px 0
  .el-checkbox__label
    display: none
  .date
    font-size: 16px
    color: #8694A4
  .info
    p
      font-weight: bold
      margin: 0
      line-height: 24px
      &.red
        color: #ff0000
      &.green
        color: #2ecc71
    .ml-10
      padding-left: 10px
  .status
    height: 46px
    img
      width: 46px
  .btn-block
    display: flex
    align-items: center
    justify-content: center
    .call
      height: 40px
      padding: 0
      border: 0
      &:hover
        opacity: 0.7
      img
        width: 40px
  .cc-adm-item .el-loading-spinner
    margin-top: -8px
</style>
